import Vue from 'vue';

/**
 * Returns the main menu items for My section
 * Used by both the sidebar in My/index.vue and dropdown in Topbar/Device.vue
 *
 * @returns {Array} Array of menu items with titles, links, and additional properties
 */
export const getMainMenuItems = () => {
  const i18n = Vue.prototype.$t || (key => key);

  return [
    {
      title: i18n('NEWS'),
      link: '/news',
      alwaysClickableWithoutDevice: true,
    },
    {
      title: i18n('HOW_TO_SIDELOAD'),
      link: '/my/faq',
      alwaysClickableWithoutDevice: true,
    },

    {
      title: i18n('BUY_PLUS'),
      link: '/my/plus',
    },
    {
      title: i18n('INSTALL_CONFIGURE_YOUR_DEV_ACCOUNT_PLUS'),
      link: '/my/apple',
    },
    {
      title: i18n('INSTALL_APPS_WITH_FREE_DEV_ACCOUNT'),
      link: '/my/free-apple',
    },
    /* {
            title: i18n('INSTALL_CONFIGURE_3RD_PARTY_CERTIFICATE'),
            link: '/my/certificate',
        }, */
    {
      title: i18n('MY_DEVICES'),
      link: '/my/devices',
    },
    {
      title: i18n('MY_BILLING'),
      link: '/my/billing',
    },
    {
      title: i18n('MY_APPS_TITLE'),
      link: '/my/apps',
    },
    {
      title: i18n('MY_INSTALLATION_HISTORY'),
      link: '/my/installation-history',
    },
    {
      title: i18n('MY_DYLIBS'),
      link: '/my/dylibs',
    },
    {
      title: i18n('MY_REPOSITORIES'),
      link: '/my/repos',
    },
    /* {
          title: i18n('CHECK FOR UPDATES'),
          link: '/my/updates',
        }, */
    {
      title: i18n('CONFIGURE_FEATURES'),
      link: '/my/configure',
    },
    {
      title: i18n('VIEW DEVICE STATUS'),
      link: '/my/status',
    },
    {
      title: i18n('CHANGE_EMAIL'),
      link: '/my/change-email',
    },
    {
      title: i18n('LINK_APPLE_SILICON_MAC'),
      link: '/appdb-tools',
    },

    {
      title: i18n('ENABLE_JIT_AND_CHECK'),
      link: '/enable-jit',
    },
    {
      title: i18n('PAIR_DEVICE_IN_JIT_OR_FREE_MODE'),
      link: '/appdb-jitpair',
    },
    {
      title: i18n('SUPPORT_DESK'),
      link: '/my/support',
    },
    {
      title: i18n('TROUBLESHOOTING'),
      link: 'https://rtfm.dbservices.to/#/troubleshooting/app-installations',
      external: true,
      target: '_blank',
    },
    {
      title: i18n('UNLINK THIS DEVICE'),
      link: '/my/unlink',
    },
  ];
};

export default getMainMenuItems;
